module.exports = __webpack_public_path__ + "static/media/img-satisfied_on.1cb66598.svg";